import { mountModal } from './helper/dynamic-modal';

export const info = (message: string, params?: { fadeOut: boolean }) => {
  const fadeOut = params?.fadeOut || false;
  return mountModal({ slot: message, props: { withCloseButton: !fadeOut, fadeOut } });
};
